import React from 'react';

interface Props {
  currentStep: number;
}

const FULL_WIDTH = 100;

export const Carousel = ({ currentStep, children }: React.WithChildren<Props>) => {
  return (
    <div
      className="m-0 flex flex-nowrap p-0 transition-transform duration-700"
      style={{
        transform: `translateX(${currentStep * -FULL_WIDTH}%)`,
      }}
    >
      {React.Children.map(children, child => (
        <div className="w-full shrink-0">{child}</div>
      ))}
    </div>
  );
};
